"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessResponse = exports.GetBusinessesRowResponse = exports.GetBusinessesRequest = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const ResponseBase_1 = require("../ResponseBase");
class GetBusinessesRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], GetBusinessesRequest.prototype, "name", void 0);
exports.GetBusinessesRequest = GetBusinessesRequest;
class GetBusinessesRowResponse extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], GetBusinessesRowResponse.prototype, "businessId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], GetBusinessesRowResponse.prototype, "name", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], GetBusinessesRowResponse.prototype, "isSuperAPIEnabled", void 0);
exports.GetBusinessesRowResponse = GetBusinessesRowResponse;
class GetBusinessResponse extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: GetBusinessesRowResponse }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInstance)(GetBusinessesRowResponse, { each: true }),
    (0, tslib_1.__metadata)("design:type", Array)
], GetBusinessResponse.prototype, "businesses", void 0);
exports.GetBusinessResponse = GetBusinessResponse;
